import React, { useState } from "react";
interface CloseProps {
  size?: number | string;
  className?: string;
  onClick?: () => void;
  color?: string;
}

const Close: React.FC<CloseProps> = ({
  size = 20,
  className,
  onClick,
  color = "#F7F9F9",
}) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);
  const style = size ? { width: size, height: size } : undefined;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      style={style}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <path
        d="M15 5L5 15M5 5L15 15"
        stroke={isHovered ? "#0094BD" : color}
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Close;
